import { CARRIER_BRIDGE_LABEL } from "kontrolEdge/helpers/carrierBridgeName";

/**
 * Every visible string of the Carrier Bridge admin screens, in one place. The
 * product name itself comes from `carrierBridgeName.ts`, shared with the
 * customer views.
 */
export { CARRIER_BRIDGE_LABEL };

export const carrierBridgeAdminText = {
  searchPlaceholder: "Find by attribute or value",
  addButton: `Add ${CARRIER_BRIDGE_LABEL}`,
  noVlan: "-",
  status: {
    active: "Active",
    draft: "Draft",
  },
  modal: {
    createTitle: `Add ${CARRIER_BRIDGE_LABEL}`,
    editTitle: `Edit ${CARRIER_BRIDGE_LABEL}`,
    viewTitle: `${CARRIER_BRIDGE_LABEL} Details`,
    sections: {
      service: "SERVICE",
      connectivity: "CONNECTIVITY",
      details: "DETAILS",
    },
    customerPort: "Customer port",
    customer: "Customer",
    customerHint: "From the port",
    carrier: "Carrier",
    circuitId: "Circuit ID (optional)",
    vlan: "VLAN",
    wholePort: "Use the whole port (no VLAN)",
    mbps: "Bandwidth (Mbps)",
    serviceId: "Service ID",
    serviceIdPending: "Generated on save (50-XXXXXX)",
    name: "Name",
    namePlaceholder: `${CARRIER_BRIDGE_LABEL} - 50-XXXXXX`,
    draft: "Draft (VLAN not assigned yet)",
    loadingOptions: "Loading…",
    selectPort: "Select a port",
    selectCarrier: "Select a carrier",
    noCarriers: "No carriers available. Add one in Admin Center → Carriers.",
    cancel: "Cancel",
    close: "Close",
    save: "Save",
  },
  delete: {
    title: "Are you sure?",
    description: (serviceId: string) =>
      `This will permanently delete ${CARRIER_BRIDGE_LABEL} ${serviceId} and its status history. This action cannot be undone.`,
    confirm: "Delete",
    cancel: "Cancel",
    blockedTitle: "This service can't be deleted",
    blockedConfirm: "Got it",
  },
} as const;
